module.exports = __webpack_public_path__ + "static/media/USPGetAhead.73ad99d1.png";